module.exports = __webpack_public_path__ + "img/DECREMENT.9602978d.svg";